import { CollectionService } from './base.service';

class Service extends CollectionService {
  constructor() {
    super('/warehouse');
  }
  fetchWarehouseList = (filters) =>
    this.client.get('/warehouse/list', { params: filters });
  fetchWarehousemanList = (filters) =>
    this.client.get('/warehouseman', { params: filters });
  fetchPartnerList = (filters) =>
    this.client.get('/warehouse/partner', { params: filters });
  fetchMyWarehouseList = (filters, exHeaders) =>
    this.client.get('/auth/warehouse-list', {
      params: filters,
      headers: exHeaders && exHeaders,
    });
  createPackCode = (payload) =>
    this.client.post('/warehouse/cn-create-pack-code', payload);
  createShipmentCode = (payload) =>
    this.client.post('/warehouse/cn-create-shipment-code', payload);
  getPackinglist = (payload) =>
    this.client.post('/warehouse/cn-get-packing-list', payload);
  getShipmentList = (payload) =>
    this.client.post('/warehouse/cn-get-shipment-list', payload);
  cnSplitUpdate = (payload) =>
    this.client.post('/warehouse/cn-split-update', payload);
  packingInsertBill = (payload) =>
    this.client.post('/warehouse/cn-packing-insert-bill', payload);
  shipmentInsertPL = (payload) =>
    this.client.post('/warehouse/cn-shipment-insert-packinglist', payload);
  shipmentInsertPLParnter = (payload) =>
    this.client.post(
      '/warehouse/cn-shipment-insert-packinglist-partner',
      payload
    );
  packingRemoveBill = (payload) =>
    this.client.post('/warehouse/cn-packing-remove-bill', payload);
  getPackingDetail = (payload) =>
    this.client.post('/warehouse/cn-get-packing-detail', payload);
  shipmentRemovePL = (payload) =>
    this.client.post('/warehouse/cn-shipment-remove-pl', payload);
  getShipmentDetail = (payload) =>
    this.client.post('/warehouse/cn-get-shipment-detail', payload);
  endPackingList = (payload) =>
    this.client.post('/warehouse/cn-end-packing-list', payload);
  endShipment = (payload) =>
    this.client.post('/warehouse/cn-end-shipment', payload);
  fetchReceivedUnknownList = () =>
    this.client.post('/warehouse/cn-received-unknown-list');
  CNImportItem = (payload) =>
    this.client.post('/warehouse/cn-import-item', payload);
  VNImportItem = (payload) =>
    this.client.post('/warehouse/vn-import-item', payload);
  CNItemSplit = (payload) =>
    this.client.post('/warehouse/cn-item-slit', payload);
  getWarehouseInventoryList = (payload) =>
    this.client.post('/warehouse/inventory-list', payload);
  getOrderValid = (payload) =>
    this.client.post('/warehouse/get-order-valid-for-export', payload);
  vnOrderExport = (payload) =>
    this.client.post('/warehouse/vn-order-export', payload);
  getDetailShipmentMNF = (payload) =>
    this.client.post('/warehouse/get-detail-shipment-mnf', payload);
  getDetailPLReport = (payload) =>
    this.client.post('/warehouse/get-detail-pl-report', payload);
  getShipmentPortList = (payload) =>
    this.client.post('/warehouse/shipment-port-list', payload);
  getShipmentPortDetail = (payload) =>
    this.client.post('/warehouse/shipment-port-detail', payload);
  shipmentPortUpdate = (payload) =>
    this.client.post('/warehouse/shipment-port-update', payload);
  getBillsPrint = (payload) =>
    this.client.post('/warehouse/get-bills-print', payload);
  packingInsertMultiBill = (payload) =>
    this.client.post('/warehouse/packinglist-insert-m', payload);
  editPL = (id, payload) =>
    this.client.post(`/warehouse/pl/${id}/update`, payload);
  editSM = (id, payload) =>
    this.client.post(`/warehouse/sm/${id}/update`, payload);
  unlockPL = (id, payload) =>
    this.client.post(`/warehouse/pl/${id}/unlock`, payload);
  uploadWebcamImgHandler = (payload) =>
    this.client.post(`/warehouse/cn-upload-webcam-img`, payload);
}

export default new Service();
